<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn" v-if="isShowBtn">
      <el-select
        class="select_btn_style"
        v-model="filters.deptLevelCodeSelect"
        placeholder="所属学院"
      >
        <el-option
          v-for="(item, i) in deptList"
          :key="i"
          :label="item.deptName"
          :value="item.deptLevelCode"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.displayClientTypes"
        placeholder="展示终端"
        multiple
      >
        <el-option
          v-for="(item, i) in typeList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.liveStatus"
        placeholder="直播状态"
      >
        <el-option
          v-for="(item, i) in liveList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.onlineStatus"
        placeholder="上线状态"
      >
        <el-option
          v-for="(item, i) in onlineList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.name"
        placeholder="直播名称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" :title="'查询'" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import { getSysParamByTypes } from "@/api/sysParam";
import { collegeSimpleFullList } from "@/api/dept";
import butn from "@/components/button/index";
export default {
  components: {
    butn,
  },
  data() {
    return {
      filters: {
        displayClientTypes: [],

      },
      onlineList: [],
      typeList: [],
      liveList: [],
      deptList: []
    };
  },
  props: {
    isShowBtn: {
      type: Boolean,
      default: () => false,
    },
  },
  created() {
    collegeSimpleFullList().then(res => {
      if (!res || res.code != 0) return;
      res.data.splice(0, 0, {
        deptLevelCode: "",
        deptName: "全部",
      });
      this.deptList = res.data;
    });
    this.getSysParamByTypes(["LIVE_STATUS", "ONLINE_STATUS", "DISPLAY_CLIENT_TYPE"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["ONLINE_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["LIVE_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.onlineList = res.data["ONLINE_STATUS"] || [];
        this.liveList = res.data["LIVE_STATUS"] || [];
        this.typeList = res.data["DISPLAY_CLIENT_TYPE"] || [];
      });
    },
    initData() {
      if (this.filters.displayClientTypes.includes("")) {
        delete this.filters.displayClientTypes;
        this.$emit("search", { ...this.filters, t: new Date().getTime() });
        return;
      }

      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {
        displayClientTypes: []
      };
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .el-select__tags {
  overflow: hidden;
  span {
    display: flex;
  }
}
</style>
